// extracted by mini-css-extract-plugin
export default {"redDot":"RedDot_redDot__jH8Sa","circle":"RedDot_circle__GhGCN"};